import React from 'react';
import { Box, Typography } from '@mui/material';
import { dateFormate } from '../../../../utils/helper';
import useInterveneSx from '../../hooks/useInterveneSx';

function InfoRow({ label, value, styles }) {
  if (value === null || value === undefined || value === '') return null;

  return (
    <Box sx={styles.infoRow}>
      <Typography sx={styles.infoLabel}>{label}</Typography>
      <Typography sx={styles.infoValue}>{value}</Typography>
    </Box>
  );
}

export default function UserInfoSection({ userDetails }) {
  const styles = useInterveneSx().profile;

  if (!userDetails?.phone_number) {
    return (
      <Typography sx={styles.infoEmpty}>Select a user to view details.</Typography>
    );
  }

  const payload = userDetails?.payload || {};

  return (
    <Box>
      <InfoRow label="User Type" value={userDetails.user_type} styles={styles} />
      <InfoRow
        label="Created At"
        value={userDetails.created_at ? dateFormate(userDetails.created_at, 'DD-MM-YYYY h:mm A') : null}
        styles={styles}
      />
      <InfoRow
        label="Last Active"
        value={userDetails.updated_at ? dateFormate(userDetails.updated_at, 'DD-MM-YYYY h:mm A') : null}
        styles={styles}
      />
      <InfoRow label="City" value={payload.city} styles={styles} />
      <InfoRow label="Area" value={payload.area} styles={styles} />
      <InfoRow label="Pincode" value={payload.pincode} styles={styles} />
      <InfoRow label="Primary Count" value={payload.primary_count} styles={styles} />
      <InfoRow label="Society Name" value={payload.society_name} styles={styles} />
      <InfoRow label="Society Type Quality" value={payload.society_type_quality} styles={styles} />
      <InfoRow label="Type Of Entity" value={payload.type_of_entity} styles={styles} />
      <InfoRow label="Designation" value={payload.designation} styles={styles} />
    </Box>
  );
}
